import { MessageSchema } from '../realm/schema';

export const Plat = 'P';

export type User = {
    id: string;
    name: string;
    imageUri: string;
    tag: string;
};

/**
 * 请求loading状态
 */
export enum LoadingState {
    LOADING = 1, // 加载中
    LOADSUCCESS = 2, // 加载成功
    LOADFAIL = 3, // 加载失败
}

/**
 * 聊天类型
 */
export enum ChatType {
    /**@docs 群聊 */
    GROUP = 'group',
    /**@docs 单聊 */
    SINGLE = 'single',
}

/*
 * 消息类型
 */
export enum MessageType {
    /**@docs 文本 */
    TEXT = 'txt',
    /**@docs 图片 */
    IMAGE = 'img',
    /**@docs 视频 */
    VIDEO = 'video',
    /**@docs 音频 */
    VOICE = 'voice',
    /**@docs 系统消息 */
    SYSTEM = 'tip',
    /**@docs 对话 */
    TALK = 'talk',
    /**@docs 文档 */
    DOCUMENT = 'doc',
    RTC_VIDEO = 'video_rtc',
    RTC_VOICE = 'voice_rtc',
    LOCAL_TIME = 'local_time', // 本地时间分割线
    DOCUMENT = 'doc', // 文件
    EMPTY = 'empty',
}

export const strToType = (str: string) => {
    switch (str) {
        case 'txt':
            return MessageType.TEXT
        case 'img':
            return MessageType.IMAGE
        case 'video':
            return MessageType.VIDEO
        case 'voice':
            return MessageType.VOICE
        case 'tip':
            return MessageType.SYSTEM
        case 'talk':
            return MessageType.TALK
        case 'doc':
            return MessageType.DOCUMENT
        case 'local_time':
            return MessageType.LOCAL_TIME
        case 'empty':
            return MessageType.EMPTY
        default:
            return MessageType.EMPTY

    }
}

/**
 * 消息状态
 */
export enum MessageMaskType {
    /**@docs 正常 */
    NOMAL = 0,
    /**@docs 删除 */
    DELETED = 1,
    /**@docs 撤回 */
    RECALL = 2,
}

/**
 * 消息审核状态
 */
export enum AuditActionStatus {
    PASS = 'pass',
    REFUSED = 'refused',
}

/**
 * 消息上报状态
 */
export enum MessageReportStatus {
    DEFAULT = 'default',
    /**@docs 已读 */
    READ = 'read',
    RECEIPT = 'receipt',
}

export interface GroupChatInfoRes {
    members: number[];
    group: {
        name: string;
        uid: number;
        cid: string;
        tid: string;
        tag?: string;
        adminUids: number[];
        ctime: number;
        namePY: string;
        namePYS: string;
        notice: string;
        tagid: number;
    };
}

/**
 * 消息查看状态
 */
export enum MessageAuditStatus {
    // 有敏感词但是审核通过，管理员展示审核成功标志
    SUCCESS = -1,
    //不展示
    GONE = -2,
    // 正常
    NOMAL = 0,
    // 含有敏感词待审核，只有管理员与自己可见
    INFO = 1,
    // 审核失败，仅管理员与自己可见，展示错误提示
    // REJECT = 2,
}

/**
 * UserList中User的类型
 */
export enum UserType {
    FRIEND = 'friend',
    COLLEAGUE = 'colleague',
    OTHER = 'other',
}

// export type ChartMessageItem = MessageSchema & {user?: UserSchema};
export type ChartMessageItem = MessageSchema;

export enum SystemCmd {
    GROUP_CREATE = 'group_create',
    GROUP_JOIN = 'group_join',
    GROUP_JOIN_KEFU = 'group_join_kefu',
    GROUP_QUIT = 'group_quit',
    GROUP_KICK = 'group_kick',
    FRI_REQ_PASSS = 'friend_request_pass',
}


/**系统消息--创建会话,加入会话 */
export interface SystemGroupIn {
    cmd: string;
    uid: number; // 拉取人
    tid: string;
    joinUids: number[]; // 被拉取人
    show: string; // "张三拉取阿珍F,阿珍2F创建会话"
}

/**系统消息--退出，踢出 */
export interface SystemGroupOut {
    cmd: string;
    uid: number; // 拉取人
    removeUid: number; // 退出人
    show: string; // "张三 退出了群聊"
}

export interface SystemFriPass {
    cmd: string;
    uid: number;
    show: string;
}
